/**
 * Sound effect types for game interactions
 * These are short, responsive sounds for immediate feedback
 */
export type SoundEffect =
  | "correct" // Positive ding for correct answers
  | "incorrect" // Gentle tone for wrong answers (not harsh)
  | "star" // Star earning chime
  | "badge" // Badge fanfare
  | "click" // Button tap sound
  | "levelComplete"; // Celebration for completing a level

/**
 * Audio categories for organization and preloading
 */
export type AudioCategory = "effects" | "prompts" | "music" | "character";

/**
 * Volume levels for different audio categories
 */
export interface VolumeSettings {
  master: number; // 0-1
  effects: number; // 0-1
  music: number; // 0-1
  prompts: number; // 0-1
}

/**
 * Audio file paths mapped by sound effect
 */
export const SOUND_EFFECT_PATHS: Record<SoundEffect, string> = {
  correct: "/audio/effects/correct.mp3",
  incorrect: "/audio/effects/incorrect.mp3",
  star: "/audio/effects/star.mp3",
  badge: "/audio/effects/badge.mp3",
  click: "/audio/effects/click.mp3",
  levelComplete: "/audio/effects/level-complete.mp3",
};

/**
 * Sounds to preload on app initialization for instant playback
 */
export const PRELOAD_SOUNDS: SoundEffect[] = [
  "correct",
  "incorrect",
  "star",
  "click",
];

/**
 * Default volume settings
 */
export const DEFAULT_VOLUME_SETTINGS: VolumeSettings = {
  master: 1,
  effects: 0.8,
  music: 0.5,
  prompts: 1,
};

/**
 * Audio playback options
 */
export interface PlayOptions {
  volume?: number; // Override default volume (0-1)
  loop?: boolean; // Loop the sound
  rate?: number; // Playback rate (0.5-2)
}
